import React, { useState,useEffect } from 'react';
import logo from '../../assets/logo.png';
import { Link } from 'react-router-dom';
import { FaTachometerAlt, FaUserTie, FaChevronDown, FaUserPlus, FaSignOutAlt, FaCog, FaHeadset } from 'react-icons/fa';
import './sidebar.css';
const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [disable, setDisable] = useState(false);
  const path = window.location.pathname;
  const openSideNav = () => {
    var sideNav: any = document.getElementById('sideNav');
    sideNav.classList.toggle('active');
  };
  const segments = path.split('/'); // ["", "assessments", "result-view"]
  const currentPage = segments[2]; // "result-view"
  useEffect(() => {
    if (currentPage === 'result-view') {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [currentPage]);
  return (
    <div
      className="md:side-nav w-[220px] bg-[#263238] z-40 fixed top-16 min-h-screen h-[100%]"
      id="sideNav"
      style={disable ? { pointerEvents: 'none' } : {}}
    >
      <div className={`pc-sidebar ${collapsed ? "collapsed" : ""}`}>
        {/* Logo Section */}
        {/* <div className="logo">
          <img src={logo} alt="Logo" width={40} />
          {!collapsed && <span style={{fontFamily:'"Inter", sans-serif' ,fontWeight:'400'}}>Third Bracket</span>}
        </div> */}
        <div className="logo" style={{ display: 'flex', justifyContent: "center" }}>
          <img src={logo} alt="logo" style={{ width: '100px' }} />
        </div>


        {/* Main Navigation */}
        <ul className="pc-navbar">
          {/* Dropdown Section */}
          <li className={`pc-item ${dropdownOpen ? "pc-dropdown" : ""}`}>
            <button className="pc-link flex items-center justify-between w-full" onClick={() => setDropdownOpen(!dropdownOpen)}>
              <div className="flex items-center">
                {/* SVG Assessment Icon */}
                <svg
                  className="pc-micon"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                  <path d="M6 8h12M6 12h12M6 16h8" />
                </svg>
                {!collapsed && <span className="pc-mtext ml-2">Assessments</span>}
              </div>

              {/* Dropdown Arrow Icon */}
              {!collapsed && (
                <svg
                  className={`ml-auto transition-transform ${dropdownOpen ? "rotate-180" : ""}`}
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              )}
            </button>

            {dropdownOpen && (
              <ul className="pc-submenu">
                <li>
                  <Link to="/assessments">New</Link>
                </li>
                <li>
                  <Link to="/completed-assessments">Completed</Link>
                </li>
              </ul>
            )}
          </li>

          {/* Settings */}
          <li className="pc-item">
            <p className="pc-link">
              {/* SVG Settings Icon */}
              <svg
                className="pc-micon"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="3" />
                <path
                  d="M19.4 15a1.9 1.9 0 01.5 2l-.5 2a2 2 0 01-1.8 1H6a2 2 0 01-1.8-1l-.5-2a1.9 1.9 0 01.5-2l1.4-1.2a8 8 0 010-4L4.2 8A1.9 1.9 0 013.7 6l.5-2A2 2 0 016 3h12a2 2 0 011.8 1l.5 2a1.9 1.9 0 01-.5 2l-1.4 1.2a8 8 0 010 4z"
                />
              </svg>
              {!collapsed && <span className="pc-mtext">Settings</span>}
            </p>
          </li>

          {/* Support */}
          <li className="pc-item">
            <p className="pc-link">
              {/* SVG Support Icon */}
              <svg
                className="pc-micon"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 16h.01M12 12a2 2 0 10-2-2" />
              </svg>
              {!collapsed && <span className="pc-mtext">Support</span>}
            </p>
          </li>

          {/* Book A Demo Button */}
          <li className="card-nav" style={{ marginTop: '45px' }}>
            <button className="pc-link" style={{ justifyContent: 'center' }}>
              {!collapsed && <span style={{ fontWeight: '700', fontFamily: '"Inter", sans-serif' }}>Book A Demo</span>}
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;